import React from 'react';
import './titleContainer.less';

export interface TitleContainerProps {
	text?: string;
	subtitle?: string;
	content?: () => React.ReactNode;
	hasGrayBackground?: boolean;
	controlPanel?: () => React.ReactNode;
}

export const TitleContainer: React.SFC<TitleContainerProps> = (props: TitleContainerProps) => {
	const { text, subtitle, content, hasGrayBackground, controlPanel } = props;
	return (
		<div className="ds-title-container">
			{text && (
				<div className={`title-container ${hasGrayBackground ? 'grayBackground' : ''}`}>
					<div>
						<span className="ds-title">{text}</span>
						{subtitle && <span className="ds-subtitle">{subtitle}</span>}
					</div>
					{controlPanel && controlPanel()}
				</div>
			)}
			<>{content && content()}</>
		</div>
	);
};
